import { render, staticRenderFns } from "./ApiBody.vue?vue&type=template&id=0b620db0&scoped=true"
import script from "./ApiBody.vue?vue&type=script&lang=js"
export * from "./ApiBody.vue?vue&type=script&lang=js"
import style0 from "./ApiBody.vue?vue&type=style&index=0&id=0b620db0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b620db0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cxy\\project\\zcy\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b620db0')) {
      api.createRecord('0b620db0', component.options)
    } else {
      api.reload('0b620db0', component.options)
    }
    module.hot.accept("./ApiBody.vue?vue&type=template&id=0b620db0&scoped=true", function () {
      api.rerender('0b620db0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/datasource/ApiBody.vue"
export default component.exports